module.exports = __webpack_public_path__ + "static/media/Slider-4.848d6e19.png";